import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

export function NewPOAChoosingAgent() {
  const navigate = useNavigate();
  
  useScrollToTop();

  const handleBack = useCallback(() => {
    navigate('../personal-info');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../multiple-agents');
  }, [ navigate ]);
  
  return (
    <div className="new-poa-choosing-agent screen-container screen">
      <ScreenHeader
        title="Choosing Your Agent"
        description="Learn how to select the right person to act as your financial agent"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What is a Financial Agent?</h3>
        <p>
          Your financial agent (also called an "attorney-in-fact") is the person you appoint 
          to make financial decisions on your behalf when you cannot do so yourself. This is 
          one of the most important decisions you'll make in creating your Power of Attorney.
        </p>

        <h3>Qualities to Look For</h3>
        <ul className="qualities-list">
          <li>
            <strong>Trustworthiness:</strong> Someone you trust completely with your financial affairs
          </li>
          <li>
            <strong>Financial Competence:</strong> Someone who understands financial matters and can 
            make sound decisions
          </li>
          <li>
            <strong>Availability:</strong> Someone who will be available when needed and willing 
            to take on this responsibility
          </li>
          <li>
            <strong>Communication Skills:</strong> Someone who can communicate effectively with 
            family members, financial institutions, and others
          </li>
          <li>
            <strong>Stability:</strong> Someone whose life is stable and who is likely to be 
            available long-term
          </li>
        </ul>

        <h3>Common Agent Choices</h3>
        <ul className="agent-options">
          <li><strong>Spouse or Partner:</strong> Most people choose their spouse or domestic partner</li>
          <li><strong>Adult Children:</strong> Often a good choice if they are financially responsible</li>
          <li><strong>Close Family Members:</strong> Siblings, parents, or other trusted relatives</li>
          <li><strong>Trusted Friends:</strong> Close friends who understand your values and wishes</li>
          <li><strong>Professional Fiduciaries:</strong> Licensed professionals who specialize in this work</li>
        </ul>

        <h3>Important Considerations</h3>
        <ul className="considerations-list">
          <li>Your agent should be at least 18 years old</li>
          <li>They should not have a criminal record or history of financial problems</li>
          <li>Consider naming a backup agent in case your first choice becomes unavailable</li>
          <li>Make sure your agent understands your values and financial goals</li>
          <li>Discuss this responsibility with your chosen agent before naming them</li>
        </ul>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            You can change your agent at any time by creating a new Power of Attorney document. 
            The new document will automatically revoke the old one.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
